import React, { useEffect, useState } from 'react'
import Editor from "@monaco-editor/react";
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';

export default function Resource() {
    const [showPopup, setShowPopup] = useState(false);
    const [resourceType, setResourceType] = useState('');
    const [resourceName, setResourceName] = useState('');
    const [authorName, setAuthorName] = useState('');
    const [resourceMode, setResourceMode] = useState('local');
    const [keywords, setKeywords] = useState('');
    const [description, setDescription] = useState('');
    const [selectedFile, setSelectedFile] = useState(null);
    const [content, setContent] = useState('');
    const active_pro_name = localStorage.getItem('selected_project_name');

    const [searchText, setSearchText] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [loadingSearch, setLoadingSearch] = useState(false);

    const [showCodePopup, setShowCodePopup] = useState(false);
    const [selectedResource, setSelectedResource] = useState(null);

    const [alertMsg, setAlertMsg] = useState('');
    const [showAlertBox, setShowAlertBox] = useState(false);
    const [membretype, setMembertype] = useState(false);
     useEffect(()=>{
        let memtype = localStorage.getItem('membership_type');
        if (memtype === 'free') {
            setMembertype(true);
        }
        const username = localStorage.getItem('membername');
        setAuthorName(username);
     })
    

    function openTiptext() {
        document.getElementById('tool_tip').style.display = 'block'
    }
    function closeTiptext() {
        document.getElementById('tool_tip').style.display = 'none'
    }
    function setResourceTypeValue(valuename) {
        setResourceType(valuename)
    }
    function openResourcepop() {
        setShowPopup(true);
    }

    function closeResourcePop() {
        setShowPopup(false);
    }


    async function uploadResource() {
        const company_id = localStorage.getItem("mem_company_id");
        const user_id = localStorage.getItem("member_id");

        // -------------------------
        // Validation
        // -------------------------

        if (!resourceName.trim()) {
            showAlert("Resource name is required");
            return;
        }

        if (resourceName.trim().length < 4) {
            showAlert("Resource name must be at least 4 characters");
            return;
        }

        if (!resourceType) {
            showAlert("Please select a resource type");
            return;
        }

        if (!description.trim()) {
            showAlert("Description is required");
            return;
        }

        if (description.trim().length < 20) {
            showAlert("Description must be at least 20 characters");
            return;
        }

        if (!keywords.trim()) {
            showAlert("Please enter keywords");
            return;
        }

        const keywordArray = keywords
            .split(",")
            .map(k => k.trim())
            .filter(k => k !== "");

        if (keywordArray.length < 2) {
            showAlert("Please enter at least 2 keywords separated by commas");
            return;
        }

        // Code validation
        if (resourceType === "code" && !content.trim()) {
            showAlert("Please write your code/documentation");
            return;
        }

        // File validation
        if (resourceType !== "code" && !selectedFile) {
            showAlert("Please upload a file");
            return;
        }

        // File type validation
        const allowedTypes = [
            "image/jpeg",
            "image/png",
            "application/pdf",
            "video/mp4",
            "application/zip",
            "application/x-rar-compressed",
            "text/plain"
        ];

        if (
            resourceType !== "code" &&
            selectedFile &&
            !allowedTypes.includes(selectedFile.type)
        ) {
            showAlert("Unsupported file type");
            return;
        }

        // File size validation (50MB)
        const maxSize = 50 * 1024 * 1024;

        if (
            resourceType !== "code" &&
            selectedFile &&
            selectedFile.size > maxSize
        ) {
            showAlert("File size must be less than 50MB");
            return;
        }

        // -------------------------
        // FormData
        // -------------------------

        const formData = new FormData();

        formData.append("company_id", company_id);
        formData.append("user_id", user_id);
        formData.append("name", resourceName);
        formData.append("author_name", authorName);
        formData.append("description", description);
        formData.append("type", resourceType);
        formData.append("visibility", resourceMode);

        formData.append(
            "keywords",
            JSON.stringify(keywordArray)
        );

        // For code resource
        if (resourceType === "code") {
            formData.append("content", content);
        }

        // For file resource
        if (resourceType !== "code" && selectedFile) {
            formData.append("file", selectedFile);
        }

        // -------------------------
        // API Call
        // -------------------------

        try {
            const response = await fetch("upload-resource.php", {
                method: "POST",
                body: formData
            });

            const data = await response.json();

            if (data.status === "success") {
                showAlert("Resource uploaded successfully");

                closeResourcePop();

                // Reset form
                setResourceName('');
                setAuthorName('');
                setDescription('');
                setKeywords('');
                setContent('');
                setSelectedFile(null);
                setResourceType('');
                setResourceMode('local');

            } else {
                showAlert(data.message || "Upload failed");
            }

        } catch (error) {
            console.error(error);
            showAlert("Upload failed");
        }
    }




    async function searchResources() {
        if (!searchText.trim()) {
            showAlert("Please enter search text");
            return;
        }

        const company_id = localStorage.getItem("mem_company_id");

        setLoadingSearch(true);

        try {
            const response = await fetch(
                `search-resource.php?company_id=${company_id}&query=${encodeURIComponent(searchText)}`
            );

            const data = await response.json();

            if (data.status === "success") {
                setSearchResults(data.data);
            }

        } catch (error) {
            console.error(error);
            showAlert("Search failed");
        }

        setLoadingSearch(false);
    }

    function viewResource(resource) {
        setSelectedResource(resource);
        setShowCodePopup(true);
    }
    function closeCodePopup() {
        setShowCodePopup(false);
        setSelectedResource(null);
    }
    function downloadResource(filePath) {
        window.open(`https://siddhartha.utopa.in/${filePath}`, "_blank");
    }


    const showAlert = (msg) => {
        setAlertMsg(msg);
        setShowAlertBox(true);
    };

    const closeAlert = () => {
        setShowAlertBox(false);
        setAlertMsg('');
    };
    return (
        <div>
            <div className='topbar_menu'>

                <button className='member_button  addmembtn' onClick={openResourcepop}>Add Resource</button>
                <p>Project name : {active_pro_name}</p>
                <p>Resource Bank</p>
                <p>This page is a place where you can find some usefull resource for your current project. </p>
            </div>
            <div className='searcharea'>
                <h2>What you want to know today?</h2>
                <div className='search_inputbox'>
                    <div className='input_box'>
                        <i class="ri-search-2-line"></i>
                        <input type="text" value={searchText} onChange={(e) => setSearchText(e.target.value)} placeholder="Search resource..." />
                        <button onClick={searchResources}>Search</button>
                    </div>

                </div>
            </div>
            <div className='search_result_list'>

                {loadingSearch && <p>Searching...</p>}

                {!loadingSearch && searchResults.map((item) => (
                    <div className="resource_card" key={item.id}>
                        <div className='resource_inner'>
                            <h3>{item.name}</h3>

                            <p>
                                {item.description
                                    ? item.description.substring(0, 300)
                                    : "No description available"}
                            </p>
                            <p>Author name : {item.author_name}</p>
                            <div className="resource_meta">
                                <span>{item.type}</span>
                                <span>{item.visibility}</span>
                            </div>

                            {item.type === "code" ? (
                                <button className='viewBTn pull_right' onClick={() => viewResource(item)}>
                                    <i class="ri-eye-line"></i> View
                                </button>
                            ) : (
                                <button className='downlaodBTN pull_right' onClick={() => downloadResource(item.file_path)}>
                                    <i class="ri-download-2-fill"></i>Download
                                </button>
                            )}

                        </div>
                    </div>
                ))}

            </div>
            {showCodePopup && selectedResource && (
                <div className="vl_dsh_popup_vis">
                    <div className="section_pop_content">
                        <button className="section_pop_clsoe" onClick={closeCodePopup} >X</button>
                        <h2>{selectedResource.name}</h2>
                        <p>Author name : {selectedResource.author_name}</p>
                        <p>{selectedResource.description}</p>
                        <SyntaxHighlighter language="javascript">
                            {selectedResource.content}
                        </SyntaxHighlighter>
                    </div>
                </div>
            )}


            {showPopup && (
                <div className='vl_dsh_popup_vis' id="resource_pop">
                    <div className='section_pop_content'>
                        <button className='section_pop_clsoe' onClick={closeResourcePop}>X</button>
                        <div className='section_pop_divider'>&nbsp;</div>
                        <div className='section_pop_content_left'>
                            <h3>Select Resource Type</h3>
                            <ul>
                                <li><button onClick={() => setResourceTypeValue('image')}>Image</button></li>
                                <li><button onClick={() => setResourceTypeValue('document')}>Document</button></li>
                                <li><button onClick={() => setResourceTypeValue('video')}>Video</button></li>
                                <li><button onClick={() => setResourceTypeValue('archive')}>Archive</button></li>
                                <li><button onClick={() => setResourceTypeValue('code')}>Code</button></li>
                            </ul>
                        </div>
                        <div className='section_pop_content_right'>
                            <h3 className='section_pop_heading'>Upload your resource</h3>
                            <div className='section_pop_fixcontent'>
                                <p>Please give some initial information about your resource.</p>
                                <div className='section_pop_form'>
                                    <div className='section_pop_form'>
                                        <div className='section_fieldholder'>
                                            <div className='fullwidth pull_left'>
                                                <div className='vl_dsh_one_third'>
                                                    <div className='section_fieldholder'>
                                                        <label>Name</label>
                                                        <input type="text" value={resourceName} onChange={(e) => setResourceName(e.target.value)} />
                                                    </div>
                                                </div>
                                                <div className='vl_dsh_one_third'>
                                                    <div className='section_fieldholder'>
                                                        <label>Author Name</label>
                                                        <input type="text" value={authorName} onChange={(e) => setAuthorName(e.target.value)} />
                                                    </div>
                                                </div>
                                                <div className='vl_dsh_one_third'>
                                                    <div className='section_fieldholder'>
                                                        <label>Select Mode</label>
                                                        <div className='tipicon' onMouseOver={openTiptext} onMouseOut={closeTiptext}>?</div>
                                                        <div className='tip_text' id="tool_tip">
                                                            <p>Resources in local mode can only be accessed by members of your company, while resources in global mode can be accessed by all companies on the platform.</p>
                                                        </div>
                                                        <select id="resource_mode" value={resourceMode}
                                                            onChange={(e) => setResourceMode(e.target.value)}>
                                                            <option value="local">Local</option>
                                                            <option value="global">Global</option>
                                                        </select>

                                                    </div>
                                                </div>
                                            </div>
                                            <div className='fullwidth pull_left'>
                                                <div className='vl_dsh_one_half'>
                                                    <div className='section_fieldholder'>
                                                        <label>Kyewords</label>
                                                        <textarea value={keywords}
                                                            onChange={(e) => setKeywords(e.target.value)}></textarea>
                                                        <p>Separate keywords with comma (,). DON'T USE SPACE BFORE OR AFTER COMMA</p>
                                                    </div>
                                                </div>
                                                <div className='vl_dsh_one_half'>
                                                    <div className='section_fieldholder'>
                                                        <label>Description</label>
                                                        <textarea value={description}
                                                            onChange={(e) => setDescription(e.target.value)}></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='section_pop_typedisplay'>

                                {!resourceType ? (
                                    <p>Select a resource type from the left panel</p>
                                ) : resourceType === 'code' ? (
                                    <>
                                        <label>Write Code / Documentation</label>

                                        <Editor
                                            height="200px"
                                            defaultLanguage="javascript"
                                            value={content}
                                            onChange={(value) => setContent(value)}
                                        />
                                    </>
                                ) : (
                                    <>
                                        <label>Upload File</label>
                                        <input
                                            type="file"
                                            onChange={(e) => setSelectedFile(e.target.files[0])}
                                        />
                                    </>
                                )}

                            </div>
                            <div className='vl_dsh_buttonholder'>
                                <button onClick={uploadResource}>Upload Resource</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showAlertBox && (
                <div className='vl_dsh_popup'>
                    <div className='alertbox'>
                        <div className='alertheader'>
                            <h3><i className='ri-alert-line'></i>Alert</h3>
                        </div>

                        <div className='contentarea'>
                            <p>{alertMsg}</p>
                        </div>

                        <div className='alert_btns'>
                            <button onClick={closeAlert}>Okay</button>
                        </div>
                    </div>
                </div>
            )}
             {membretype && (
                <div className='vl_dsh_popup activebillpop'>
                    <div className='alertbox'>
                        <div className='alertheader'>
                            <h3><i className='ri-alert-line'></i>Alert</h3>
                        </div>

                        <div className='contentarea'>
                            <p>Please upgrade your membership to access this page</p>
                        </div>
                         <div className='alert_btns'>
                            <button onClick={() => window.history.back()}>Back</button>
                        </div>

                    </div>
                </div>
            )}
        </div>
    )
}
